<template>
  <div class="waste">
    <div class="content">
      <div class="row">
        <div class="col-md-6 detail-info-box">
          <h1>Waste Overview</h1>
          <p>
            The waste sector is the third largest contributing sector to global
            emissions of non-CO₂ GHGs, accounting for 13% of global non-CO₂
            emissions in 2015. Global waste-sector CH₄ and N₂O historical and
            projected emissions and the mitigation potential are estimated from
            the following source categories:
          </p>
          <ul>
            <li>Landfills (CH₄)</li>
            <li>Wastewater (CH₄, N₂O)</li>
          </ul>

          <div class="tabs">
            <b-tabs content-class="mt-2">
              <b-tab title="Emission Projections" active>
                <p>
                  Between 2015 and 2030, emissions from landfills are projected to
                  grow more quickly than emissions from wastewater, increasing 30%
                  compared with 14% growth for wastewater. During this time period,
                  global waste-sector emissions are projected to increase 23% under a
                  BAU scenario, reaching 1,905 MtCO₂e in 2030. Increases in population
                  and per capita waste generation drive global waste emissions upward,
                  but historical implementation of waste-related regulations and gas
                  recovery and use has tempered this increase.
                </p>
              </b-tab>
              <b-tab title="Mitigation Assessments">
                <p>
                  Mitigation potential from the waste sector is estimated to be
                  approximately 887 MtCO₂e in 2030. This mitigation potential is 53%
                  and 37% of landfill and wastewater emissions, respectively; 47% of
                  waste-sector emissions; and 23% of total global non-CO₂ mitigation
                  potential in that year.
                </p>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="col-md-6">
          <Chart />

          <div class="row">
            <div class="col-sm-12">
              <p>
                <strong class="space-right-25">Explore Waste Sectors:</strong>
                <button type="button" @click="openDialogFromPage15">Landfills</button>
                <button type="button" @click="openDialogFromPage16">Wastewater</button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a11y-dialog
      id="main-dialog15"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference15"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <Landfills />
      </div>
    </a11y-dialog>
    <a11y-dialog
      id="main-dialog16"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference16"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <Wastewater />
      </div>
    </a11y-dialog>
  </div>
</template>

<script>
import Landfills from "@/components/waste/Landfills";
import Wastewater from "@/components/waste/Wastewater";
import Chart from "./ChartWaste";

export default {
  name: "WasteScreen",
  components: {
    Landfills,
    Wastewater,
    Chart
  },
  props: {
    msg: String
  },
  data() {
    return {
      dialog15: null,
      dialog16: null
    };
  },
  methods: {
    goToPage: function(a) {
      if (a) {
        location.href = "#/waste/" + a;
      }
    },
    assignDialogReference15(dialog15) {
      this.dialog15 = dialog15;
    },
    assignDialogReference16(dialog16) {
      this.dialog16 = dialog16;
    },
    openDialogFromPage15() {
      if (this.dialog15) {
        this.dialog15.show();
      }
    },
    openDialogFromPage16() {
      if (this.dialog16) {
        this.dialog16.show();
      }
    }
  },
  computed: {
    useFallback() {
      return typeof window.HTMLDialogElement !== "function";
    }
  }
};
</script>
<style scoped>
h1 {
  font-weight: normal;
  font-size: 2rem;
  margin-bottom: 1rem;
}
.waste {
  z-index: 0;
}
.content {
  padding-left: 150px;
  padding-right: 150px;
}
.placeholder {
  width: 80%;
  height: 80%;
  background-color: #ececec;
  margin: 10%;
}
img {
  margin-left: 3rem;
}

@media all and (max-width: 1280px) {
  .content {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media all and (max-width: 980px) {
  .waste {
    background-position: 0 -40px;
  }
  .content {
    margin-top: 70px;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media all and (max-width: 736px) {
  h1 {
    font-size: 1.5rem;
  }
  .waste {
    position: static;
  }
}
</style>
